import Phaser from 'phaser';

/** Returns the standard responsive scale config used by every game instance. */
export function responsiveScaleConfig(): Phaser.Types.Core.ScaleConfig {
  return {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 1280,
    height: 720,
  };
}

/**
 * Installs a resize/orientation listener that shows a full-screen "rotate your
 * device" overlay whenever the viewport is portrait (height > width).
 *
 * The overlay element (#rotate-hint) lives in index.html above the canvas and
 * uses `pointer-events: auto` so it naturally blocks all touch/click input to
 * the game while visible.
 *
 * Guards against a missing element — safe to call in any environment.
 */
export function installOrientationGuard(): void {
  const el = document.getElementById('rotate-hint');
  if (!el) return;

  const isPortrait = (): boolean => window.innerHeight > window.innerWidth;

  const apply = (): void => {
    el.style.display = isPortrait() ? 'flex' : 'none';
  };

  window.addEventListener('resize', apply);
  window.addEventListener('orientationchange', apply);
  apply();
}
